var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginMicrosoftLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 613",
    d: "M0 0h23v23H0z",
    style: {
      fill: "#f3f3f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 614",
    d: "M1 1h10v10H1z",
    style: {
      fill: "#f35325"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 615",
    d: "M12 1h10v10H12z",
    style: {
      fill: "#81bc06"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 616",
    d: "M1 12h10v10H1z",
    style: {
      fill: "#05a6f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 617",
    d: "M12 12h10v10H12z",
    style: {
      fill: "#ffba08"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginMicrosoftLogo);
export default __webpack_public_path__ + "static/media/login-microsoft-logo.8f0210159449404c2e3c5f5a0cc326d7.svg";
export { ForwardRef as ReactComponent };